import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
  getLeavesMakeUpSessionRequest: ["children_id", "page", "isTherapist"],
  getLeavesMakeUpSessionSuccess: ["listLeavesMake"],
  getLeavesMakeUpSessionFailure: null,
});

export const GetLeavesMakeUpSessionTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable({
  data: null,
  fetching: null,
  payload: null,
  success: null,
  error: null,
  page: null,
  children_id: null,
});

export const GetLeavesMakeUpSessionSelectors = {
  getData: (state: any) => state.getLeavesMakeUpSession.data,
  isFetching: (state: any) => state.getLeavesMakeUpSession.fetching,
  isSuccess: (state: any) => state.getLeavesMakeUpSession.success,
  hasError: (state: any) => state.getLeavesMakeUpSession.error,
};

export const request = (state: any, { children_id, page }: any) => {
  const updateData = {
    fetching: true,
    success: null,
    error: null,
    payload: null,
    children_id,
    page,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const success = (state: any, action: any) => {
  const { listLeavesMake } = action;
  const updateData = {
    fetching: false,
    success: true,
    error: false,
    listLeavesMake,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const failure = (state: any) => {
  const updateData = {
    fetching: false,
    success: false,
    error: true,
    payload: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_LEAVES_MAKE_UP_SESSION_REQUEST]: request,
  [Types.GET_LEAVES_MAKE_UP_SESSION_SUCCESS]: success,
  [Types.GET_LEAVES_MAKE_UP_SESSION_FAILURE]: failure,
});
